import React, { createContext, useState } from "react";

export let UserDetailProvider = createContext();

export default function CreateUserDataContext({ children }) {
  const [userDetails, setUserDetails] = useState({
    subscriptionDetails: {
      isSubscribe:false,
      duration: "0",
      expires: "",
    },
    startBalance: 0,
    currentBalance: 0,
  });

  return (
    <UserDetailProvider.Provider value={{userDetails,setUserDetails}}>
      {children}
    </UserDetailProvider.Provider>
  );
}
